exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.back-home-content .action[data-v-7d64ed66] {\n  width: 4.8rem;\n  height: 1.066667rem;\n  border-radius: 0.533333rem;\n  border: 0.026667rem solid #FF4633;\n  margin-top: 0.533333rem;\n  font-size: 0.426667rem;\n  font-family: PingFangSC-Regular, PingFang SC;\n  font-weight: 400;\n  color: #FF4633;\n  line-height: 1.066667rem;\n  text-align: center;\n  margin: 0 auto;\n}", ""]);

// exports
